import type { TranslateRequest, TranslateResult } from "@repo/shared/types";
import { post } from "./_client";

export async function translateText(
  text: string,
  sourceLanguage: string,
  targetLanguages: string[],
): Promise<TranslateResult> {
  return post<TranslateResult>("/internal/ai/translate", {
    text,
    sourceLanguage,
    targetLanguages,
  } satisfies TranslateRequest);
}
